import classNames from 'classnames'
import { useState } from 'react'
import { Boon } from 'web/lib/boon'
import BoonPopup from './BoonPopup'
import GalleryBoonItem from './GalleryBoonItem'

export enum BoonGalleryContext {
  Exchange,
  Wallet
}

export type GalleryBoonItemProps = {
  boons: Boon[]
  className?: string
  context?: BoonGalleryContext
}

export default function GalleryBoonItems({ boons, className = "", context = BoonGalleryContext.Exchange }: GalleryBoonItemProps) {
  const [showBoon, setShowBoon] = useState<Boon>()

  return (
    <>
      {/* Boon Popup */}
      {showBoon != null &&
        <BoonPopup
          boon={showBoon}
          context={context}
          onClose={() => {
            setShowBoon(null)
          }}
        />
      }

      <ul
        role="list"
        className={classNames(className, `mt-8 grid grid-cols-2 gap-x-4 gap-y-6 md:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8`)}
        x-max={1}
      >
        {boons.map((boon) => (
          <GalleryBoonItem
            key={boon.uid}
            boon={boon}
            context={context}
            onClick={() => {
              setShowBoon(boon)
            }} />
        ))}
      </ul>
    </>
  )
}
